import Vue from "vue";
import App from "./App.vue";
//引入store
import store from "./store";
//引入VueRouter
import VueRouter from "vue-router";
//引入路由器
import router from "./router";
//引入组件库
import md5 from "js-md5";
import Vant from "vant";

import "vant/lib/index.css";

import axios from "axios";
Vue.prototype.$axios = axios;

// import {get,post} from './httpRequest/index'

// //将方法挂载到Vue原型上
// Vue.prototype.get=get;
// Vue.prototype.post=post;
Vue.use(Vant);

Vue.prototype.$md5 = md5;
Vue.config.productionTip = false;
//应用插件
Vue.use(VueRouter);

new Vue({
  render: (h) => h(App),
  store,
  router,
  axios,
}).$mount("#app");
